import { controls } from "../../controls";

const rp561 = {
  label: "OSC.4 -Banking",
  pageLabel: "OSC.4 -Banking",
  starting: true,
  url: "rp561",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history",
  filter: [
    ...controls.displayText({tab: "filter",label: "As on Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),
        
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-3 "}),
    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  
  form:[],

  history: {
    perPage: 10,
    reportHeader: "OSC.4 -Banking",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Particulars",
        accessor: "descn",
        rwidth:"*"
      },
      {
        Header: "Amount Outstanding",
        accessor: "outstanding",
        type:"currency",
        width: 100,
        rwidth: 65
      },
      {
        Header: "Classification of assets",
        columns: [
          {
            Header: "Standard Assets",
            accessor: "standard",
            type:"currency",
            width: 100,
            rwidth: 50
          },
          {
            Header: "Sub Standard-Overdues up to 3 Years",
            accessor: "substandard",
            type:"currency",
            width: 100,
            rwidth: 50
          }
        ]
      },
      {
        Header: "Doubtful secured",
        columns: [
          {
            Header: "Overdues for 3 to 4 Years",
            accessor: "doubtful1",
            type:"currency",
            width: 100,
            rwidth: 50
          },
          {
            Header: "Overdues for 4 to 6 Years",
            accessor: "doubtful2",
            type:"currency",
            width: 100,
            rwidth: 50
          },
          {
            Header: "Overdues for more than 6 Years",
            accessor: "doubtful3",
            type:"currency",
            width: 100,
            rwidth: 50
          }
        ]
      },
      {
        Header: "Doubtful unsecured",
        accessor: "lossassets",
        type:"currency",
        width: 100,
        rwidth: 50
      },
      {
        accessor: "totalnpas",
        Header: "Total NPAs",
        type:"currency",
        width: 100,
        rwidth: 50
       },
      {
        accessor: "npa",
        Header: "% of NPAs to o/s",
        type:"currency",
        width: 100,
        rwidth: 50
      }
    ]
  }
};

export default rp561;